import React, { useContext, useState } from "react";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { toast } from "react-toastify";

const DownloadLogs = () => {
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    status: "",
  });
  const { userDetails } = useContext(UserApiContext);
  const [loading, setLoading] = useState(false);

  const statuses = [
    { val: "New File Uploaded", label: "File Uploaded" },
    { val: "Line Item Added", label: "New Lane Added" },
    { val: "Line Item Updated", label: "Lane Updated" },
    { val: "Line Item Deleted", label: "Lane Deleted" },
  ];

  const formatDateToISO = (date, isEndOfDay = false) => {
    if (!date) return null;
    const dateObj = new Date(date);
    if (isEndOfDay) {
      // set EOD
      dateObj.setUTCHours(23, 59, 59, 999);
    } else {
      dateObj.setUTCHours(0, 0, 0, 0);
    }
    return dateObj.toISOString();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDownload = async () => {
    const { fromDate, toDate, status } = filters;

    if (!fromDate || !toDate) {
      toast.error("Please select From Date, To Date");
      return;
    }

    if (new Date(fromDate) > new Date(toDate)) {
      toast.error("From Date cannot be later than To Date.");
      return;
    }

    const formattedStartDate = formatDateToISO(fromDate);
    const formattedEndDate = formatDateToISO(toDate, true);

    const payload = {
      from_timestamp: formattedStartDate,
      to_timestamp: formattedEndDate,
      action: status?.trim() === "" ? null : status,
    };
    try {
      setLoading(true);
      const uri = `${Urls.freight_master}?action=download_logs&company_id=${userDetails?.profile_company_id}`;

      const { data } = await axios.post(uri, payload);

      // if true then donwload excel
      if (data.status) {
        // if no logs are found then return
        if (data?.no_logs_found) {
          toast.info(data?.message);
          return;
        } else {
          window.open(data.uri, "_parent");
          setFilters({
            fromDate: "",
            toDate: "",
            status: "",
          });
        }
      } else {
        toast.error("Error while downloading logs");
      }
    } catch (error) {
      console.error("Error downloading logs:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <form>
        <div
          className="d-flex flex-wrap align-items-end mb-3"
          style={{ gap: "15px" }}
        >
          {/* From Date */}
          <div className="flex-grow-1">
            <label htmlFor="fromDate" className="form-label">
              From Date
            </label>
            <input
              type="date"
              id="fromDate"
              required
              name="fromDate"
              max={new Date().toISOString().split("T")[0]}
              className="form-control form-control-sm"
              value={filters.fromDate}
              onChange={handleChange}
            />
          </div>

          {/* To Date */}
          <div className="flex-grow-1">
            <label htmlFor="toDate" className="form-label">
              To Date
            </label>
            <input
              type="date"
              id="toDate"
              required
              max={new Date().toISOString().split("T")[0]}
              name="toDate"
              className="form-control form-control-sm"
              value={filters.toDate}
              onChange={handleChange}
            />
          </div>

          {/* Status */}
          <div className="flex-grow-1">
            <label htmlFor="status" className="form-label">
              Action Type
            </label>
            <select
              id="status"
              name="status"
              className="form-control form-control-sm"
              value={filters.status}
              onChange={handleChange}
            >
              <option value="">Select Action Type</option>
              {statuses.map((s) => (
                <option key={s?.val} value={s?.val}>
                  {s?.label}
                </option>
              ))}
            </select>
          </div>

          {/* Download Button */}
          <button
            type="button"
            onClick={handleDownload}
            className="btn btn-primary"
            disabled={loading}
            style={{ minWidth: "120px" }}
          >
            {loading ? "Downloading..." : "Download"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DownloadLogs;
